import type { Address } from 'viem'

import { ChainId } from '@morpho-org/blue-sdk'

export interface StakedTokenConfig {
  sourceToken: Address
  stakedToken: Address
  description?: string
}

const stakedTokensConfig: Partial<Record<ChainId, StakedTokenConfig[]>> = {
  [ChainId.EthMainnet]: [
    {
      sourceToken: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH
      stakedToken: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0', // wstETH
      description: 'Wrapped liquid staked Ether 2.0'
    }
  ]
}

/**
 * Gets staked token configuration for a specific chain.
 * @param chainId - Chain identifier
 * @returns Array of staked token configs or empty array if none exist
 */
export function getStakedTokens(chainId: ChainId): StakedTokenConfig[] {
  return stakedTokensConfig[chainId] || []
}
